import React from 'react'
import type { IconDefaultProps } from '../../models/types'

const WhereToSleepIcon = ({
  className,
  color
}: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={className || 'rf-h-6 rf-w-8'}
      viewBox='0 0 65.614 65'
    >
      <g transform='translate(-36 -27.199)'>
        <path
          d='M101.654,41.267,69.607,27.276a.92.92,0,0,0-.741,0L37.248,41.269a.921.921,0,0,0-.548.842V54.353a.92.92,0,0,0,1.841,0V42.71l30.7-13.585,31.125,13.588v11.64a.92.92,0,1,0,1.841,0V42.111A.921.921,0,0,0,101.654,41.267Z'
          transform='translate(-0.593 0)'
          fill={color || '#9f077d'}
        />
        <path
          d='M209.08,82.744a7.873,7.873,0,0,0-1.932-.244,7.548,7.548,0,1,0,7.548,7.548c0-.257-.016-.52-.033-.767a.92.92,0,0,0-1.837.123c.015.216.029.444.029.644a5.707,5.707,0,1,1-5.707-5.707,6.007,6.007,0,0,1,1.474.186.92.92,0,1,0,.459-1.783Z'
          transform='translate(-138.502 -46.817)'
          fill={color || '#9f077d'}
        />
        <path
          d='M231.753,91.652a.92.92,0,0,0-1.266,1.337l1.734,1.642a.92.92,0,0,0,1.274-.008l7.456-7.241a.92.92,0,0,0-1.283-1.321l-6.823,6.626Z'
          transform='translate(-164.408 -49.611)'
          fill={color || '#9f077d'}
        />
        <path
          d='M77.206,224.163V214.052a3.256,3.256,0,0,0-3.252-3.252H43.64a3.256,3.256,0,0,0-3.252,3.252v10.111A4.453,4.453,0,0,0,36,228.611v18.1a.921.921,0,0,0,.92.92h4.587a.921.921,0,0,0,.92-.92v-3.467H75.181v3.421a.921.921,0,0,0,.911.92l4.587.046h.009a.921.921,0,0,0,.92-.92v-18.1A4.454,4.454,0,0,0,77.206,224.163ZM43.64,212.641H73.954a1.413,1.413,0,0,1,1.411,1.411v10.11H73.141v-4.188a3.671,3.671,0,0,0-3.667-3.667h-5.63a3.671,3.671,0,0,0-3.667,3.667v4.188H57.539v-4.188a3.671,3.671,0,0,0-3.667-3.667h-5.63a3.671,3.671,0,0,0-3.667,3.667v4.188H42.228v-10.11A1.413,1.413,0,0,1,43.64,212.641ZM71.3,224.162H62.019v-4.188a1.828,1.828,0,0,1,1.826-1.826h5.63a1.828,1.828,0,0,1,1.826,1.826Zm-15.6,0H46.417v-4.188a1.828,1.828,0,0,1,1.826-1.826h5.63a1.828,1.828,0,0,1,1.826,1.826ZM40.449,226H77.16a2.611,2.611,0,0,1,2.608,2.608v6.167H37.841v-6.167A2.611,2.611,0,0,1,40.449,226Zm36.573,19.753v-3.43a.92.92,0,0,0-.92-.92H41.507a.92.92,0,0,0-.92.92v3.467H37.841v-9.174H79.768v9.165Z'
          transform='translate(0 -155.434)'
          fill={color || '#9f077d'}
        />
        <path
          d='M366.043,305.164V296.82a.921.921,0,0,0-.92-.92h-15.6a.92.92,0,0,0-.92.92v15.924a.92.92,0,1,0,1.841,0v-6.228H364.2v6.228a.92.92,0,1,0,1.841,0v-6.718a.919.919,0,0,0,0-.862Zm-15.6-.489v-6.934H364.2v6.934Z'
          transform='translate(-264.644 -227.479)'
          fill={color || '#9f077d'}
        />
        <path
          d='M391.894,324.5H388.12a.92.92,0,0,0,0,1.841h3.774a.92.92,0,1,0,0-1.841Z'
          transform='translate(-297.322 -251.692)'
          fill={color || '#9f077d'}
        />
        <path
          d='M379.31,197.46a.921.921,0,0,0,.871-1.219l-2.3-6.719a.921.921,0,0,0-.871-.622h-4.587a.921.921,0,0,0-.871.622l-2.3,6.719a.921.921,0,0,0,.871,1.219h3.513v3.375h-1.979a.92.92,0,0,0,0,1.841h5.922a.92.92,0,0,0,0-1.841h-2.1V197.46Zm-6.23-6.719h3.271l1.671,4.878h-6.613Z'
          transform='translate(-282.083 -136.894)'
          fill={color || '#9f077d'}
        />
      </g>
    </svg>
  )
}

export default WhereToSleepIcon
